"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SparkCacheMetadata = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

/**
 * Metadata for the SparkCache object. This is stored as a separate object constructed of primitives
 * so that it can be reliably serialized and deserialized to/from JSON.
 */
var SparkCacheMetadata = /*#__PURE__*/function () {
  function SparkCacheMetadata() {
    var lastRefreshed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var uid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
    (0, _classCallCheck2.default)(this, SparkCacheMetadata);
    (0, _defineProperty2.default)(this, "uid", void 0);
    (0, _defineProperty2.default)(this, "lastServerRefresh", void 0);
    this.uid = uid;
    this.lastServerRefresh = lastRefreshed;
  }
  /**
   * Determines if the data is beyond the specified age in minutes
   * maxAge - Maximum age in minutes before data is considered stale
   */


  (0, _createClass2.default)(SparkCacheMetadata, [{
    key: "isStale",
    value: function isStale() {
      var maxAge = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 60;

      if (!this.lastServerRefresh) {
        return true;
      } else {
        var diff = Math.abs(new Date().getTime() - this.lastServerRefresh) / 1000 / 60;
        return diff > maxAge;
      }
    }
    /**
     * Determines if SparkCache requires a refresh
     * @param uid - Firebase uid of current user
     * @param maxAge - Maximum age in minutes before data is considered stale
     */

  }, {
    key: "needsRefresh",
    value: function needsRefresh(uid) {
      var maxAge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;
      return this.isStale(maxAge) || this.uid != uid;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new SparkCacheMetadata(this.lastServerRefresh, this.uid);
    }
  }]);
  return SparkCacheMetadata;
}();

exports.SparkCacheMetadata = SparkCacheMetadata;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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